import { createApi } from '@reduxjs/toolkit/query/react'

import { apiPrivate } from '~/redux/utils/hom-api'

export const bootcampSplitApi = createApi({
  reducerPath: 'bootcampApi',
  tagTypes: [
    'ActivityData',
    'Bootcamp',
    'List',
    'Details',
    'Overview',
    'Boss',
    'List User Data',
    'Overview User Data',
    'Earned chests in every gym',
    'BestAccuracy',
    'ActivitySetAccuracy',
    'Quests',
    'SubjectWithCourseList',
  ],
  baseQuery: apiPrivate,
  endpoints: () => ({}),
})
